import React from "react";
import { Image, Modal, ModalBody } from "react-bootstrap";
import { AiFillAccountBook } from "react-icons/ai";
import { ModalHeaderBlack, MyModal } from "../../features/RadConnStyle";

export default function CapturedImageViewer(props) {
  const [state, setState] = props.showImage;

  return (
    <MyModal
      show={state.show}
      size="xl"
      onHide={() => setState({ show: false })}
      backdrop={false}
      centered
    >
      <ModalHeaderBlack closeButton>
        <AiFillAccountBook
          style={{ color: "yellow", fontSize: "30px", margin: "0 5px 0 5px" }}
        />
        {state.imageName}
      </ModalHeaderBlack>
      <ModalBody>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flex: "1",
            height: "90vh",
            overflow: "scroll",
          }}
        >
          <Image src={state.imagePath}></Image>
        </div>
      </ModalBody>
    </MyModal>
  );
}
